// extracted by mini-css-extract-plugin
export default {"selectorModal":"SelectorModal-module__selectorModal___CwVDj"};